<template>
    <div class="tit-wrap">
        <v-row>
            <v-col cols="12" md="" data-aos="fade-right" data-aos-delay="100">
                <h3 v-if="this.$slots['title']" class="tit tit--bar"><slot name="title" /></h3>
                <p v-if="this.$slots['text']" class="txt txt--lg txt--dark pl-md-20px"><slot name="text" /></p>
            </v-col>
            <v-col v-if="this.$slots['button']" cols="12" md="auto" class="text-right" data-aos="fade-left" data-aos-delay="200">
                <slot name="button" />
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        title: { type: String },
        text: { type: String },
    },
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
